
export const tableData = [
    {
        key: "ErrorRange",
        type: "props",
        parameterType: "Number",
        desc: "允许的误差值",
        remark: "默认10",
    },
    {
        key: "isShow",
        type: "props",
        parameterType: "Boolean",
        desc: "是否显示",
        remark: "",
    },
    {
        key: "@success",
        type: "methods",
        parameterType: "",
        desc: "成功返回",
        remark: "",
    },
    {
        key: "@fail",
        type: "methods",
        parameterType: "",
        desc: "失败返回",
        remark: "",
    }
]